/** @format */

import { Drawer, formatMoney } from "//nuxe-spa.com/cdn/shop/t/2/assets/theme.js?v=110341055786519461861783491591";

var FiltersSelection = class extends HTMLElement {
	constructor() {
		super();
		this.filters = this.dataset.filters.split(",");
		this.options = {};
		this.btn = this.querySelector(".btn");
		this.linkUrl = this.btn?.href;
		this.init();
	}
	init() {
		this.filters.map((filter) => {
			const select = this.querySelector(`[role="${filter}"]`);
			select.addEventListener("change", (e) =>
				this.changeOptions(e.target.dataset.filter),
			);
			this.options[filter] = Array.from(select.options);
		});
		this.changeOptions(this.filters[0]);
	}
	positionIcons() {
		this.filters.map((filter) => {
			const item = this.querySelector(`[role="${filter}"]`).parentElement;
			const icon = item.querySelector(".care-filters__form__item__icon");
			const select = item.querySelector(".care-filters__form__item__select");
			const text = select.options[select.selectedIndex].text;
			const measurer = document.createElement("span");
			measurer.innerHTML = text;
			measurer.style.display = "inline-block";
			measurer.classList.add("care-filters__form__item__select");
			item.append(measurer);
			const measurerWidth = measurer.clientWidth;
			measurer.remove();
			const selectPosition = { x: select.offsetLeft, y: select.offsetTop };
			icon.style.left = `${selectPosition.x + measurerWidth}px`;
			icon.style.top = `${selectPosition.y}px`;
		});
	}
	createLink() {
		if (!this.btn || !this.linkUrl) return;
		let linkUrl = `${this.linkUrl}?`;
		this.filters.map((filter, index) => {
			const item = this.querySelector(`[role="${filter}"]`).parentElement;
			const select = item.querySelector(".care-filters__form__item__select");
			const value = select.value.replaceAll(":", "%3A").replaceAll("/", "%2F");
			linkUrl += `${index > 0 ? "&" : ""}filter.p.m.custom.search_axis${
				index + 1
			}=${value}`;
		});
		this.btn.href = linkUrl;
	}

	changeOptions(filter) {
		const filterIndex = this.filters.indexOf(filter);
		for (let i = filterIndex + 1; i < this.filters.length; i++) {
			const value = this.querySelector(`[role="${this.filters[i - 1]}"]`).value;
			const select = this.querySelector(`[role="${this.filters[i]}"]`);
			const options = this.options[this.filters[i]];
			select.innerHTML = "";
			options.map((option) => {
				const include = option.dataset.include;
				if (include.includes(value)) select.append(option);
			});
		}
		this.positionIcons();
		this.createLink();
	}
};
if (!window.customElements.get("filters-selection")) {
	window.customElements.define("filters-selection", FiltersSelection);
}

// dropdown mobile
var DropdownMobile = class extends HTMLButtonElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.addEventListener("click", (event) => {
			const parent = this.parentElement;
			parent.classList.toggle("open");
			if (this.dataset.fill) {
				this.fillSelectedDropdown(parent);
			}
		});
	}

	fillSelectedDropdown(parent) {
		parent.querySelectorAll(".js-dropdown-mobile-text").forEach((item) =>
			item.addEventListener("click", (event) => {
				parent.querySelector(".js-dropdown-mobile-selected").innerText =
					event.target.innerText;
			}),
		);
	}
};

if (!window.customElements.get("dropdown-mobile")) {
	window.customElements.define("dropdown-mobile", DropdownMobile, {
		extends: "button",
	});
}

// MAINMENU
var Mainmenu = class extends HTMLElement {
	constructor() {
		super();
		this.tabmenu = window.matchMedia("screen and (min-width: 1440px)").matches;
		this.burger = window.matchMedia("screen and (max-width: 1439px)").matches;
	}
	connectedCallback() {
		if (this.burger) {
			this.initBurgerMenu();
		}
		if (this.tabmenu) {
			this.initTabMenu();
		}
	}
	initBurgerMenu() {
		this.addEventListener("click", function (e) {
			const el = e.target;
			// open submenu
			if (el.classList.contains("js-open-submenu")) {
				e.preventDefault();
				el.closest(".menu_item").classList.add("menu_item_active");
			}
			// close submenus
			if (el.classList.contains("js-close-menu")) {
				if (el.closest(".menu_item_level_1.menu_item_active")) {
					e.stopImmediatePropagation();
					el.closest(".menu_item_level_1").classList.remove("menu_item_active");
				} else {
					el.closest(".menu_item_level_0").classList.remove("menu_item_active");
				}
			}
		});
	}
	initTabMenu() {
		this.addEventListener("mouseover", function (e) {
			const el = e.target;
			// level 0
			if (el.classList.contains("js-open-submenu")) {
				const rootSelectedMenu = el.closest(".menu_item");
				// active level 0
				this.querySelector(
					".menu_item_active.menu_item_level_0",
				)?.classList.remove("menu_item_active");
				rootSelectedMenu.classList.add("menu_item_active");
				// active first tabmenu (level 1) of level 0
				rootSelectedMenu
					.querySelector(".menu_item_tab:first-child")
					.classList.add("menu_submenu_tab_active");
				rootSelectedMenu
					.querySelector(".menu_submenu_tab_item:first-child")
					.classList.add("menu_submenu_tab_active");
			} else if (el.classList.contains("menu_item_level_0_link")) {
				// unactive level 0 if no child submenu
				this.querySelector(
					".menu_item_active.menu_item_level_0",
				)?.classList.remove("menu_item_active");
			}
			// level 1 => tabs
			if (el.classList.contains("js-open-tab")) {
				const parent = el.closest(".menu_item_tab");
				const index = findSelectorIndex(parent) + 1;
				// remove
				this.querySelectorAll(".menu_item_tab").forEach((tab) => {
					tab.classList.remove("menu_submenu_tab_active");
				});
				this.querySelectorAll(".menu_submenu_tab_item").forEach((tab) => {
					tab.classList.remove("menu_submenu_tab_active");
				});

				// add
				parent.classList.add("menu_submenu_tab_active");
				parent
					.closest(".menu_submenu_type_tab")
					.querySelector(".menu_submenu_tab_item:nth-child(" + index + ")")
					?.classList.add("menu_submenu_tab_active");
			}
		});
		this.addEventListener("mouseleave", function (e) {
			const el = e.target;
			// remove active level 0
			this.querySelector(
				".menu_item_active.menu_item_level_0",
			)?.classList.remove("menu_item_active");
			// remove active level 1
			this.querySelector(
				".menu_item_tab.menu_submenu_tab_active",
			).classList.remove("menu_submenu_tab_active");
			this.querySelector(
				".menu_submenu_tab_item.menu_submenu_tab_active",
			).classList.remove("menu_submenu_tab_active");
		});
	}
};
if (!window.customElements.get("main-menu")) {
	window.customElements.define("main-menu", Mainmenu);
}

//
class ObfuscatedLink extends HTMLElement {
	constructor() {
		super();
		this.href = this.getAttribute("data-href");
		this.target = this.getAttribute("target");
	}

	connectedCallback() {
		this.addEventListener("click", () => {
			if (this.href) {
				if (this.target == "_blank") {
					window.open(this.href, "_blank");
					return;
				}
				window.location.href = this.href;
			}
		});

		this.addEventListener("auxclick", (e) => {
			if (this.href) {
				window.open(this.href, "_blank");
			}
		});
	}

	disconnectedCallback() {
		this.removeEventListener("click");
		this.removeEventListener("auxclick");
	}
}
if (!window.customElements.get("obfuscated-link")) {
	window.customElements.define("obfuscated-link", ObfuscatedLink);
}

class EnableSubmit extends HTMLElement {
	constructor() {
		super();
		this.checkbox = this.querySelector(".checkbox");
		this.submitBtn = this.checkbox
			.closest("form")
			.querySelector("button[type=submit]");
	}
	connectedCallback() {
		this.checkbox.addEventListener("change", (e) => {
			if (e.target.checked) {
				this.submitBtn.disabled = false;
			} else {
				this.submitBtn.disabled = true;
			}
		});
	}
}
if (!window.customElements.get("enable-submit")) {
	window.customElements.define("enable-submit", EnableSubmit);
}

class ShowMoreButton extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.addEventListener("click", this.showContent);
		this.content = document.getElementById(this.dataset.targetId) || document.querySelector(this.dataset.targetSelector);
		this.checkButton();
	}

	checkButton() {
		const containerHeight = this.content.clientHeight;
		const contentHeight = this.content.scrollHeight;
		this.style.display =
			containerHeight < contentHeight ? "inline-block" : "none";
	}

	showContent() {
		if (!this.content) return;
		this.content.style.display = "block";
		this.style.display = "none";
	}
}
if (!window.customElements.get("show-more-button")) {
	window.customElements.define("show-more-button", ShowMoreButton);
}

class FAQContent extends HTMLElement {
	constructor() {
		super();
		this.subjects =
			this.querySelector(".faq__subjects").querySelectorAll(".faq__subject");
		this.faqsSections = this.querySelectorAll(".faq__section");
		this.questions = document.querySelectorAll(".faq__qa");
		this.search = this.querySelector(".faq__search");
		this.searchIsActive = false;
	}

	connectedCallback() {
		this.subjects.forEach((subject) =>
			subject.addEventListener("click", () => this.displayFAQ(subject)),
		);
		this.questions.forEach((q) =>
			q.addEventListener("click", () => {
				q.classList.toggle("open");
			}),
		);
		this.search.addEventListener("keyup", () => this.displaySearchResult());
	}

	disconnectedCallback() {
		this.subjects.forEach((subject) => subject.removeEventListener("click"));
		this.question.forEach((subject) => subject.removeEventListener("click"));
		this.search.removeEventListener("keyup");
	}

	displayFAQ(subject) {
		if (this.searchIsActive) {
			this.resetSearch();
		}

		this.subjects.forEach((subject) => subject.classList.remove("active"));
		subject.classList.add("active");
		const subjectToDisplay = subject.getAttribute("subject");
		this.faqsSections.forEach((section) => {
			if (section.classList.contains(subjectToDisplay)) {
				section.classList.remove("hidden");
			} else {
				section.classList.add("hidden");
			}
		});
	}

	displaySearchResult() {
		this.searchIsActive = true;
		const value = this.search.value;

		this.faqsSections.forEach((section) => {
			section.classList.add("hidden");

			const QAs = section.querySelectorAll(".faq__qa");
			QAs.forEach((qa) => {
				qa.classList.add("hidden");

				const question = qa.querySelector(".faq__qa--question");
				const content = question.dataset.question;
				const answer = qa.querySelector(".faq__qa--answer");
				const answerContent = answer.dataset.answer;

				if (content.includes(value)) {
					section.classList.remove("hidden");
					qa.classList.remove("hidden");

					const instances = new RegExp(value, "g");
					const hightlightedText = content.replace(
						instances,
						`<span class="highlight">${value}</span>`,
					);
					question.innerHTML = hightlightedText;
				}
				if (answerContent.includes(value)) {
					section.classList.remove("hidden");
					qa.classList.remove("hidden");

					const instances = new RegExp(value, "g");
					const hightlightedText = answerContent.replace(
						instances,
						`<span class="highlight">${value}</span>`,
					);
					answer.querySelector(".metafield-rich_text_field").innerHTML =
						hightlightedText;
					if (value != "") {
						qa.classList.add("open");
					} else {
						qa.classList.remove("open");
					}
				}
			});
		});
	}

	resetSearch() {
		this.search.value = "";
		this.questions.forEach((qa) => {
			qa.classList.remove("hidden");

			const question = qa.querySelector(".faq__qa--question");
			question.innerHTML = question.dataset.question;
		});
		this.searchIsActive = false;
	}
}
if (!window.customElements.get("faq-content")) {
	window.customElements.define("faq-content", FAQContent);
}

// HIDE YOTPO REVIEWS IF EMPTY
let hideEmptyReviewsBlock = () => {
	checkElementInDom("#yotpo-reviews-main-widget").then(() => {
		const reviewsBlock = document.querySelector("#yotpo-reviews-main-widget");
		if (reviewsBlock.querySelector(".yotpo-empty-state") != undefined) {
			// console.log('empty reviews')
			reviewsBlock.closest(".section").style.display = "none";
		}
	});
};

//************* */ TOOLS : **********//
// check if selector exists in dom
function checkElementInDom(el) {
	if (document.querySelector(el) != null) {
		return new Promise((resolve, reject) => {
			resolve();
		});
	} else {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				checkElementInDom(el).then(resolve);
				// Recursively call and resolve the promise when the element is found
			}, 2000);
		});
	}
}
// find index of selector
function findSelectorIndex(child) {
	return Array.from(child.parentNode.children).indexOf(child);
}
//************* */ END TOOLS : **********//

// if page product page
if (document.querySelector(".shopify-section--main-product") != undefined) {
	hideEmptyReviewsBlock();
}

// OVERRIDE EVENT MENU QIKIFY
let eventMenuMobile = () => {
	let nav = document.querySelector("navigation-drawer");
	// bouton retour
	nav.addEventListener("click", function (e) {
		let el = e.target;
		if (el.className == "tmenu_item_link") {
			if (el.closest(".tmenu_item_level_1.tmenu_item_active")) {
				el.closest(".tmenu_item_level_1").classList.remove("tmenu_item_active");
			} else {
				el.closest(".tmenu_item_level_0").classList.remove("tmenu_item_active");
			}
		}
	});
};
eventMenuMobile();

// for product set routine

var QuickBuyMultipleDrawer = class extends Drawer {
	constructor() {
		super();
		this.addEventListener("dialog:after-hide", this._submitForm);
	}
	_submitForm() {
		// const form = this.querySelector("#facet-form");
		// if (HTMLFormElement.prototype.requestSubmit) {
		//   form.requestSubmit();
		// } else {
		//   form.dispatchEvent(new Event("submit", { cancelable: true }));
		// }
	}
	async show() {
		this.style.display = "block";
		return super.show();
	}
	onVariantAdded() {
		const tempContent = document.createElement("div");
		//tempContent.innerHTML = event.detail.cart["sections"]["variant-added"];
		//this.replaceChildren(...tempContent.querySelector(".shopify-section").children);
		this.show();
	}
};
if (!window.customElements.get("quick-buy-multiple-drawer")) {
	window.customElements.define(
		"quick-buy-multiple-drawer",
		QuickBuyMultipleDrawer,
	);
}

// show password
var ShowPassword = class extends HTMLElement {
	constructor() {
		super();
		this.icon = this.querySelector(".js-icon");
		this.input = this.querySelector("input");
	}
	connectedCallback() {
		this.icon.addEventListener("click", this.showPass.bind(this));
	}
	showPass() {
		this.classList.toggle("show");
		const input = this.input;
		if (input.type == "password") {
			input.type = "text";
		} else {
			input.type = "password";
		}
	}
};
if (!window.customElements.get("show-password")) {
	window.customElements.define("show-password", ShowPassword);
}

// COLLAPSE TEXT (lire plus)
var CollapseText = class extends HTMLElement {
	constructor() {
		super();
		const prose = this.getAttribute("prose");
		const lineClampInit = () => {
			if (prose) {
				const proseContent = this.querySelector(".prose");
				this.maxLines = this.getAttribute("max-lines");
				this.clampClass = "line-clamp-prose-" + this.maxLines;
				const elemHeight = proseContent.offsetHeight;
				const lineHeight = window
					.getComputedStyle(proseContent)
					.lineHeight.replace("px", "");
				const lines = elemHeight / lineHeight;
				// console.log('elemHeight',proseContent.offsetHeight);
				// console.log('lineHeight',lineHeight);
				// console.log('lines',lines);
				// console.log('max-lines',this.maxLines);
				// console.log('clampClass',this.clampClass);

				if (isNaN(lines) || lines <= this.maxLines) {
					this.classList.remove(this.clampClass);
					this.classList.add("active");
				} else {
					this.classList.add(this.clampClass);
					this.classList.remove("active");
				}
			}
		};
		this.addEventListener("click", (e) => {
			let el = e.target;
			if (el.className == "collapse__action") {
				this.classList.add("active");
				if (prose) {
					this.classList.remove(this.clampClass);
				}
			}
		});
		lineClampInit();
	}
};
if (!window.customElements.get("collapse-text")) {
	window.customElements.define("collapse-text", CollapseText);
}

// CLICK AREA
var ClickArea = class extends HTMLElement {
	constructor() {
		super();
		this.disabled = this.getAttribute("disable-click");
		this.targetSelector = this.querySelector(this.getAttribute("target"));
	}
	connectedCallback() {
		this.addEventListener("click", (e) => {
			if (!this.disabled) {
				e.stopPropagation();
				e.stopImmediatePropagation();
				this.targetSelector.click();
			}
		});
	}
};
if (!window.customElements.get("click-area")) {
	window.customElements.define("click-area", ClickArea);
}

var BatchDiscount = class extends HTMLElement {
	constructor() {
		super();
		this.formQty = document.forms[this.getAttribute("form")].quantity;
		this.bundles = this.querySelectorAll(".batch_discount__product");
	}
	connectedCallback() {
		this.bundles.forEach((bundle) =>
			bundle.addEventListener("click", () => this.selectBundle(bundle)),
		);
	}
	disconnectedCallback() {
		this._abortController.abort();
	}

	selectBundle(bundle) {
		this.bundles.forEach((bundle) => bundle.classList.remove("active"));

		bundle.classList.add("active");
		this.changeQty(bundle);
		this.updateMainCtaPrice(bundle);
	}

	updateMainCtaPrice(bundle) {
		const priceInCta = [
			document.querySelector(".product-info__buy-buttons--price"),
			document.querySelector(
				".product-quick-add .product-info__buy-buttons--price",
			),
			document.querySelector(".product-quick-add__variant sale-price"),
		];
		const newPrice = bundle.querySelector("sale-price");
		if (!priceInCta || !newPrice) return;
		priceInCta.forEach((price) => {
			price.textContent = newPrice.textContent;
		});
	}

	changeQty(bundle) {
		this.formQty.value = bundle.dataset.quantity;
	}
};
if (!window.customElements.get("batch-discount")) {
	window.customElements.define("batch-discount", BatchDiscount);
}

document.addEventListener("JOIN_STORIES_ADD_TO_CART", async (event) => {
	const { orderId, variantId } = event.detail;
	const formData = new FormData();
	formData.append("id", variantId);
	await fetch(`${Shopify.routes.root}cart/add.js`, {
		body: formData,
		method: "POST",
	});

	document.dispatchEvent(new CustomEvent("cart:refresh"));
	fetch(`${Shopify.routes.root}cart.js`)
		.then((res) => res.json())
		.then((res) => {
			document.dispatchEvent(
				new CustomEvent("cart:count-update", {
					detail: {
						count: res.item_count,
					},
				}),
			);
			window.JoinStories.resolveAddToCart(orderId);
		});
});

document.addEventListener("JOIN_STORIES_SEE_CART", function (event) {
	document.dispatchEvent(new CustomEvent("variant:add"));
	window.JoinStories.closePlayer();
});

// Animations
import {
	timeline,
	stagger,
} from "//fr.nuxe.com/cdn/shop/t/6/assets/vendor.min.js?v=52426788336887041471710425097";

function animateTextBlock({
	containerSelector,
	innerSelector,
	duration,
	staggerDelay,
	easing,
} = {}) {
	document.querySelectorAll(containerSelector).forEach((container) => {
		const inners = Array.from(container.querySelectorAll(innerSelector));
		inners.forEach((el) => {
			el.style.transform = "translateY(100px)";
			el.style.filter = "blur(5px)";
		});

		if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches)
			return;

		const obs = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						timeline([
							[
								inners,
								{
									transform: ["translateY(100px)", "translateY(0)"],
									filter: ["blur(5px)", "blur(0px)"],
								},
								{ duration, easing, delay: stagger(staggerDelay) },
							],
						]);
						observer.unobserve(entry.target);
					}
				});
			},
			{
				root: null,
				rootMargin: "0px 0px -30% 0px",
				threshold: 0.3,
			},
		);

		obs.observe(container);
	});
}

function initHeadingsAnimations(root = document) {
	root
		.querySelectorAll('[data-enable-headings-animation="true"]')
		.forEach((el) => {
			animateTextBlock({
				containerSelector: `#${el.id}`,
				innerSelector: ".mask__inner",
				duration: 2,
				staggerDelay: 0.3,
				easing: "cubic-bezier(0.25,0.46,0.45,0.94)",
			});
		});
}
[
	"DOMContentLoaded",
	"shopify:section:load",
	"shopify:section:select",
	"shopify:section:deselect",
	"shopify:block:load",
	"shopify:block:select",
	"shopify:block:deselect",
].forEach((evt) => {
	document.addEventListener(evt, (event) => {
		initHeadingsAnimations(event.target);
	});
});

class VideoBanner extends HTMLElement {
	connectedCallback() {
		this.type = this.dataset.animationType || "reveal";
		this.overlays = Array.from(this.querySelectorAll(".overlay-block"));
		this.videos = Array.from(this.querySelectorAll("video-media"));
		if (
			this.type === "scroll" &&
			window.matchMedia("(prefers-reduced-motion: no-preference)").matches
		) {
			this._initScrollAnimation();
		}
	}

	_initScrollAnimation() {
		this.initialScale = parseFloat(this.dataset.initialScale) || 0.5;
		this.scrollDistance =
			parseInt(this.dataset.scrollDistance, 10) || window.innerHeight * 1.2;
		this.style.setProperty("--initial-scale", this.initialScale);
		this.style.setProperty("--scroll-distance", `${this.scrollDistance}px`);
		this._onScroll = this._onScroll.bind(this);
		window.addEventListener("scroll", this._onScroll, { passive: true });
	}

	_onScroll() {
		const rect = this.getBoundingClientRect();
		if (rect.top <= 0 && rect.bottom >= window.innerHeight) {
			const scrolled = -rect.top;
			const progress = Math.min(
				Math.max(
					scrolled /
						parseFloat(
							getComputedStyle(this).getPropertyValue("--scroll-distance"),
						),
					0,
				),
				1,
			);
			const scale = this.initialScale + progress * (1 - this.initialScale);
			this.videos.forEach((v) => (v.style.transform = `scale(${scale})`));
		} else if (rect.bottom < window.innerHeight) {
			window.removeEventListener("scroll", this._onScroll);
			this.style.setProperty("--scroll-distance", "0px");
			this.videos.forEach((v) => (v.style.transform = "scale(1)"));
			this.scrollIntoView({ behavior: "auto", block: "start" });
		} else {
			this.videos.forEach(
				(v) => (v.style.transform = `scale(${this.initialScale})`),
			);
		}
	}
}
if (!window.customElements.get("video-banner")) {
	window.customElements.define("video-banner", VideoBanner);
}

class TripleMea extends HTMLElement {
	connectedCallback() {
		this.items = Array.from(this.querySelectorAll(".triple-mea__item"));
		this.medias = this.items
			.map((i) => i.querySelector(".triple-mea__media > *"))
			.filter((el) => el);

		if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches)
			return;

		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this._onVisible();
						obs.unobserve(entry.target);
					}
				});
			},
			{
				root: null,
				threshold: 0.25,
				rootMargin: "0px 0px -25% 0px",
			},
		);

		observer.observe(this);
	}

	_onVisible() {
		timeline([
			[
				this.items,
				{
					opacity: [0, 1],
					transform: ["scale(0.8)", "scale(1)"],
				},
				{
					duration: 1.4,
					easing: "cubic-bezier(0.25,0.46,0.45,0.94)",
					delay: stagger(0.2),
				},
			],
		]);
		timeline([
			[
				this.medias,
				{ transform: ["scale(1)", "scale(1.05)"] },
				{ duration: 1.3, easing: "cubic-bezier(0.25,0.46,0.45,0.94)" },
			],
		]);
	}
}
if (!window.customElements.get("triple-mea")) {
	window.customElements.define("triple-mea", TripleMea);
}

class HighlightProduct extends HTMLElement {
	connectedCallback() {
		this.items = Array.from(
			this.querySelectorAll(".highlight-product__product"),
		);
		if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
			this.items.forEach((item) => {
				item.style.opacity = "1";
				item.style.transform = "none";
			});
			return;
		}
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this._onVisible(entry.target);
						obs.unobserve(entry.target);
					}
				});
			},
			{
				root: null,
				threshold: 0.3,
				rootMargin: "0px 0px -30% 0px",
			},
		);
		this.items.forEach((item) => {
			item.style.opacity = "0";
			item.style.transform = "translate(80px, 50px) rotate(-3deg)";
			item.style.transition = "none";
			observer.observe(item);
		});
	}
	_onVisible(item) {
		timeline([
			[
				[item],
				{
					transform: [
						"translate(80px, 50px) rotate(-3deg)",
						"translate(0, 0) rotate(0deg)",
					],
					opacity: ["0", "1"],
				},
				{
					duration: 1,
					easing: "cubic-bezier(0.25,0.46,0.45,0.94)",
				},
			],
		]);
	}
}
if (!window.customElements.get("highlight-product")) {
	window.customElements.define("highlight-product", HighlightProduct);
}

const joinObserver = new MutationObserver(() => {
	const target = document.querySelector(".join-sticky-host");
	if (target) {
		target.classList.add("visible");
	}
});

joinObserver.observe(document.body, { childList: true, subtree: true });

const Embroidery = class extends HTMLElement {
	constructor() {
		super();
		this.productId = this.dataset.productId;
		this.embroideryId = this.dataset.embroideryId;
		this.addToCartButton = this.querySelector(".embroidery_add");

		this.inputs = this.querySelectorAll(".embroidery__choices__input input");

		this.embroideryLabel = this.dataset.embroideryLabel;
	}
	connectedCallback() {
		this.checkValidity();

		this.addToCartButton.addEventListener("click", () =>
			this.addProductsToCart(),
		);
		this.inputs.forEach((input) =>
			input.addEventListener("input", () => this.checkValidity()),
		);
	}
	disconnectedCallback() {}

	getChoicesValues() {
		this.config = {
			font: this.querySelector(".embroidery_fonts input:checked")?.value,
			color: this.querySelector(".embroidery_colors input:checked")?.value,
			text: this.querySelector(".embroidery_text input")?.value,
		};
	}

	checkValidity() {
		this.getChoicesValues();

		const formIsValid =
			this.config.font && this.config.color && this.config.text;

		if (formIsValid) {
			this.addToCartButton.removeAttribute("disabled");
		} else {
			this.addToCartButton.setAttribute("disabled", "true");
		}

		return formIsValid;
	}

	addProductsToCart() {
		if (!this.checkValidity()) {
			return false;
		}

		this.addToCartButton.setAttribute("aria-busy", "true");

		const sectionCartDrawer = document
			.querySelector("cart-drawer")
			?.closest(".shopify-section")
			?.id?.replace("shopify-section-", "");
		const choiceCombinationId = `choice-${this.config.font}-${this.config.color}-${this.config.text}`;

		fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				items: [
					{
						id: this.embroideryId,
						quantity: 1,
						properties: {
							_Broderie: this.config.text,
							_Police: this.config.font,
							_Couleur: this.config.color,
							_linkKey: choiceCombinationId,
							_hideLineItem: true,
						},
					},
					{
						id: this.productId,
						quantity: 1,
						properties: {
							[this.embroideryLabel]: this.config.text,
							_linkKey: choiceCombinationId,
						},
					},
				],
				sections: sectionCartDrawer,
			}),
		})
			.then((response) => {
				this.updateCart(response);
			})
			.catch((error) => {
				console.error("Erreur :", error);
			});
	}

	async updateCart(response) {
		const responseJson = await response.json();

		if (response.ok) {
			const cartContent = await (
				await fetch(`${Shopify.routes.root}cart.js`)
			).json();
			cartContent.sections = responseJson.sections;

			this.addToCartButton.removeAttribute("aria-busy");

			this.dispatchEvent(
				new CustomEvent("variant:add", {
					bubbles: !0,
					detail: {
						items: responseJson.hasOwnProperty("items")
							? responseJson.items
							: [responseJson],
						cart: cartContent,
					},
				}),
			);
			document.documentElement.dispatchEvent(
				new CustomEvent("cart:change", {
					bubbles: !0,
					detail: { baseEvent: "variant:add", cart: cartContent },
				}),
			);
			document.documentElement.dispatchEvent(
				new CustomEvent("embroidery:add", {
					bubbles: !0,
				}),
			);
		} else {
			this.addToCartButton.removeAttribute("aria-busy");
			this.dispatchEvent(
				new CustomEvent("cart:error", {
					bubbles: !0,
					detail: { error: responseJson.description },
				}),
			);
		}
	}
};
if (!window.customElements.get("embroidery-ctn")) {
	window.customElements.define("embroidery-ctn", Embroidery);
}

const EmbroideryDrawer = class extends Drawer {
	connectedCallback() {
		super.connectedCallback();
		document.addEventListener("embroidery:add", () => this.hide());
	}

	get shouldAppendToBody() {
		return !1;
	}
	get openFrom() {
		return "right";
	}
};
if (!window.customElements.get("embroidery-drawer")) {
	window.customElements.define("embroidery-drawer", EmbroideryDrawer);
}

const Gifting = class extends HTMLElement {
	constructor() {
		super();
		this.linkedLineItemId;

		this.noteForm = this.querySelector(".gifting-note_form");
		this.noteFormInputs = this.noteForm?.querySelectorAll(
			".gifting-note_form__field",
		);
		this.noteProduct = this.querySelector(".gifting-note_product");
		this.noteQtyInput = this.noteProduct?.querySelector(".quantity-input");
		this.hasNoteProduct = !!this.noteProduct?.length;
		this.noteLabel = this.dataset.label;

		this.qtyInputs = this.querySelectorAll(".quantity-input");

		this.priceCtn = this.querySelector(".gifting__final-price");

		this.items = [];
		this.addToCartButton = this.querySelector(".gifting_add");

		document.addEventListener("click", (event) => {
			const button = event.target.classList.contains("gifting_open-button");
			if (!button) return;

			document.dispatchEvent(
				new CustomEvent("gifting:panel:open", {
					detail: { lineItemId: event.target.dataset.lineItemId },
				}),
			);
		});
		document.addEventListener("gifting:panel:open", (e) => this.initDrawer(e));
	}
	connectedCallback() {
		this.checkValidity();

		this.addToCartButton.addEventListener("click", () =>
			this.addProductsToCart(),
		);

		this.noteQtyInput?.addEventListener("change", () =>
			this.handleFormDisplay(),
		);

		this.noteFormInputs?.forEach((input) =>
			input.addEventListener("input", () => this.checkValidity()),
		);
		this.qtyInputs.forEach((input) =>
			input.addEventListener("change", () => {
				this.checkValidity();
				this.handlePriceDisplay();
			}),
		);
	}

	disconnectedCallback() {}

	initDrawer(event) {
		this.linkedLineItemId = event.detail.lineItemId;
	}

	checkValidity() {
		let isValid = false;
		this.qtyInputs.forEach((input) => {
			if (input.value > 0) {
				isValid = true;
			}
		});

		if (this.hasNoteProduct) {
			isValid = this.checkFormValidity();
		}

		if (isValid) {
			this.addToCartButton.removeAttribute("disabled");
		} else {
			this.addToCartButton.setAttribute("disabled", "true");
		}

		return isValid;
	}

	checkFormValidity() {
		this.config = {};
		this.getFormNoteValues();

		const formIsValid =
			this.config._for && this.config._from && this.config._message;

		return formIsValid;
	}

	handlePriceDisplay() {
		let totalPrice = 0;
		this.qtyInputs.forEach((input) => {
			const qty = input.value;
			const unitPrice = input.dataset.price;
			const price = qty * unitPrice;

			totalPrice += price;
		});

		const formatedPrice = formatMoney(totalPrice);
		this.priceCtn.innerHTML = formatedPrice;
	}

	handleFormDisplay() {
		if (this.noteQtyInput.value == 0) {
			this.noteForm.classList.add("hidden");
			this.hasNoteProduct = false;
		} else {
			this.noteForm.classList.remove("hidden");
			this.hasNoteProduct = true;

			this.noteForm.parentElement.scrollTo({
				top: this.noteForm.parentElement.scrollHeight,
				behavior: "smooth",
			});
		}
	}

	addProductsToCart() {
		if (!this.checkValidity()) {
			return false;
		}

		this.addToCartButton.setAttribute("aria-busy", "true");

		this.items = [];
		this.getWrapProducts();

		if (this.hasNoteProduct) {
			const item = {
				id: this.noteQtyInput.dataset.id,
				quantity: Number(this.noteQtyInput.value),
				properties: {
					_linkedLineItem: this.linkedLineItemId,
					...this.config,
					[this.noteLabel]: this.config._for,
				},
			};
			this.items.push(item);
		}

		const sectionCartDrawer = document
			.querySelector("cart-drawer")
			?.closest(".shopify-section")
			?.id?.replace("shopify-section-", "");

		fetch("/cart/add.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				items: this.items,
				sections: sectionCartDrawer,
			}),
		})
			.then((response) => this.updateCart(response))
			.catch((error) => {
				console.error("Erreur :", error);
			});
	}

	getWrapProducts() {
		const wrapProducts = this.querySelectorAll(
			".gifting-wrap_product .quantity-input",
		);

		wrapProducts.forEach((wrap) => {
			const qty = Number(wrap.value);
			if (qty !== 0) {
				const item = {
					id: wrap.dataset.id,
					quantity: qty,
					properties: {
						_linkedLineItem: this.linkedLineItemId,
					},
				};
				this.items.push(item);
			}
		});
	}

	getFormNoteValues() {
		this.config = {
			_for: this.noteForm.querySelector('[name="for"]')?.value,
			_from: this.noteForm.querySelector('[name="from"]')?.value,
			_message: this.noteForm.querySelector('[name="message"]')?.value,
		};
	}

	async updateCart(response) {
		const responseJson = await response.json();

		if (response.ok) {
			const cartContent = await (
				await fetch(`${Shopify.routes.root}cart.js`)
			).json();
			cartContent.sections = responseJson.sections;

			this.dispatchEvent(
				new CustomEvent("variant:add", {
					bubbles: !0,
					detail: {
						items: responseJson.hasOwnProperty("items")
							? responseJson.items
							: [responseJson],
						cart: cartContent,
					},
				}),
			);
			document.documentElement.dispatchEvent(
				new CustomEvent("cart:change", {
					bubbles: !0,
					detail: { baseEvent: "variant:add", cart: cartContent },
				}),
			);
			document.documentElement.dispatchEvent(
				new CustomEvent("embroidery:add", {
					bubbles: !0,
				}),
			);
		} else {
			this.dispatchEvent(
				new CustomEvent("cart:error", {
					bubbles: !0,
					detail: { error: responseJson.description },
				}),
			);
		}
		this.addToCartButton.removeAttribute("aria-busy");
	}
};
if (!window.customElements.get("gifting-engine")) {
	window.customElements.define("gifting-engine", Gifting);
}

const GiftingDrawer = class extends Drawer {
	connectedCallback() {
		super.connectedCallback();
		document.addEventListener("embroidery:add", () => this.hide());
	}

	get shouldAppendToBody() {
		return !1;
	}
	get openFrom() {
		return "right";
	}
};
if (!window.customElements.get("gifting-drawer")) {
	window.customElements.define("gifting-drawer", GiftingDrawer);
}

const FidelityDrawer = class extends Drawer {
	connectedCallback() {
		super.connectedCallback();
	}

	get shouldAppendToBody() {
		return !1;
	}
	get openFrom() {
		return "right";
	}
};
if (!window.customElements.get("fidelity-drawer")) {
	window.customElements.define("fidelity-drawer", FidelityDrawer);
}
